import { Injectable } from 'angular-ts-decorators';
import { Domain } from './domain';

/**
 * Service that provides OAuth functionality for payment methods integration
 */
@Injectable('oauth')
export class Oauth {
  constructor(
    private $http: ng.IHttpService,
    private domain: Domain,
  ) {
    'ngInject';
  }

  /**
   * Gets OAuth settings required for authorization
   * @param username
   * @return
   * Promise that resolves with OAuth settings
   */
  getOauthSettings(username: string): ng.IPromise<any> {
    return this.$http
      .get(
        `${this.domain.getSpynl()}/pos/get-oauth-settings?username=${username}`,
        {
          headers: { 'Content-Type': 'text/xml; charset=utf-8' },
          withCredentials: true,
        },
      )
      .then((response: any) => response.data);
  }

  /**
   * Sends authorization code to backend for token retrieval
   * @param auth_code
   * @param username
   * The authorization code received from OAuth provider
   * @return
   * Promise that resolves with the backend response
   */
  sendAuthCodeToBackend(auth_code: string, username: string): ng.IPromise<any> {
    return this.$http
      .post(
        `${this.domain.getSpynl()}/pos/mollie-save-access-tokens`,
        { data: { auth_code, username } },
        {
          headers: { 'Content-Type': 'text/xml; charset=utf-8' },
          withCredentials: true,
        },
      )
      .then((response: any) => response.data);
  }
}
